import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=df49c96e&scoped=true&"
import script from "./AppFooter.vue?vue&type=script&lang=js&"
export * from "./AppFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppFooter.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AppFooter.vue?vue&type=style&index=1&id=df49c96e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df49c96e",
  null
  
)

export default component.exports